import React from "react";

export default class Header extends React.Component {
  render() {
    return (
      <div className="row text-center py-5">
        <div className="col-12">
          <h1 className="display-4">{this.props.title}</h1>
        </div>
        <div className="col-4 offset-4 col-md-2 offset-md-5">
          <hr></hr>
        </div>
        <div className="col-12">
          <h3><small>{this.props.subtitle}</small></h3>
        </div>
      </div>

    )
  }
}
